import CheckIcon from '@mui/icons-material/Check';
import { IconButton } from '@mui/material';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import MapComponent from '/@/components/map';
import Popup from '/@/components/popup';
import { _ } from '/@/locale';
import { convertCountryBoundsToGoogleLatLng } from '/@/views/fields/field-new-v2/utils';
import SnackBar from '../snack-bar';
import styles from './styles.module.css';

@autobind
export default class PopupMap extends Component {
    static propTypes = {
        onClose: PropTypes.func,
        children: PropTypes.node,
        visible: PropTypes.bool.isRequired,
        onSelect: PropTypes.func,
        country: PropTypes.object.isRequired,
        zoomPosition: PropTypes.string,
        showErrorBanner: PropTypes.bool,
        field: PropTypes.object,
        fields: PropTypes.arrayOf(
            PropTypes.shape({
                _id: PropTypes.string.isRequired,
                geometry: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
                iconType: PropTypes.oneOf(['point', 'polygon', 'trialCorn', 'trialSoy']),
            })
        ).isRequired,
    };

    componentDidUpdate(prevProps) {
        // Focus map when visibility changes
        if (this.props.field && this.map) {
            setTimeout(() => this.map.fitPoints(this.props.field.geometry), undefined, false);
        } else {
            if (!prevProps.visible && this.props.visible) {
                setTimeout(() => this.focusMap(), 100);
            }
        }
    }

    focusMap() {
        if (!this.map) return;
        const googleBounds = convertCountryBoundsToGoogleLatLng(this.props.country.bounds);
        this.map.fitBounds(googleBounds);
    }

    setMapRef(ref) {
        this.map = ref;
        if (this.props.visible) {
            this.focusMap();
        }
    }

    handleMapClick(point) {
        this.props.onSelect(point);
    }

    handleMdaZoneSelected() {
        setTimeout(this.props.onClose, 500);
    }

    render() {
        const { visible, onClose, fields, zoomPosition, showErrorBanner } = this.props;
        return (
            <Popup onClose={onClose} visible={visible} className={styles.sizePopup}>
                <MapComponent
                    ref={this.setMapRef}
                    fields={fields || []}
                    country={this.props.country.code}
                    overlay={null}
                    offline={false}
                    simplifyPolygons={false}
                    onClick={this.props.onSelect && this.handleMapClick}
                    onFieldClick={() => {}}
                    onOverlayChange={() => {}}
                    trackEvent={() => {}}
                    zoomPosition={zoomPosition}
                    zoomControls={true}
                    selectedField={undefined}
                    radius={false}
                    onOverlayClose={() => {}}
                    noGeocoder
                />
                {showErrorBanner && (
                    <SnackBar>
                        <span>{_('No es una zona válida')}</span>
                    </SnackBar>
                )}
                {fields && fields.length > 0 && !this.props.field && (
                    <div className={styles.buttonControls}>
                        <IconButton
                            onClick={this.handleMdaZoneSelected}
                            sx={{
                                background: 'white !important',
                            }}
                        >
                            <CheckIcon />
                        </IconButton>
                    </div>
                )}
            </Popup>
        );
    }
}
